import {Link, useParams} from 'react-router-dom'
import {useTranslation} from 'react-i18next'
import {PageHeading} from '@/components/page-heading'
import {HelpIcon} from '@/components/help-icon'
import {PerfilCargoTabs} from '@/components/perfil-cargo-tabs'
import {RequisitosCargo} from '@/components/requisitos-cargo'
import {useOperatorPage} from '@/components/no-access-state'
import {useCapabilities} from '@/hooks/empresa/organizacion/use-businesses'
import {useGodModeReadOnly} from '@/hooks/platform/use-god-mode'
import {usePerfilCargo} from '@/hooks/empresa/perfil_cargo/use-perfiles-cargo'

export function RequisitosCargoPage() {
  const {t} = useTranslation()
  const {businessId, positionId} = useParams()
  const {business, guard} = useOperatorPage(businessId)
  const capabilities = useCapabilities(businessId)
  const godReadOnly = useGodModeReadOnly()
  // Solo por el nombre del cargo; la pestaña Perfil ya dejó este detalle en caché.
  const perfil = usePerfilCargo(businessId, positionId)
  if (guard) return guard
  return (
    <div className="space-y-5" data-testid="requisitos-cargo-page">
      <Link className="text-sm underline" to={`/businesses/${businessId}/sgsst/perfiles-cargo`}>
        {t('perfilCargo.detalle.volver')}
      </Link>
      <PageHeading
        title={t('requisitoCargo.titulo')}
        subtitle={perfil.data?.cargo}
        ayuda={
          <HelpIcon
            label={t('common.help.iconLabelFor', {campo: t('requisitoCargo.titulo')})}
            testId="requisitos-criterio">
            <p>{t('requisitoCargo.intro')}</p>
            <p className="mt-1.5">{t('requisitoCargo.base.sin_verificar')}</p>
          </HelpIcon>
        }
      />
      <PerfilCargoTabs businessId={businessId!} positionId={positionId!} />
      {business && (
        <RequisitosCargo
          businessId={businessId!}
          positionId={positionId!}
          canEdit={capabilities.sgsst_firmar && !godReadOnly}
          razonBloqueo={godReadOnly ? t('perfilCargo.bloqueoModoDios') : capabilities.firmar_bloqueado_por}
        />
      )}
    </div>
  )
}
